import React, { useEffect, useRef } from "react";
import { Box, Typography, Card, IconButton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { getCustomerInteractionRequest } from "../../redux/CustomerInteraction/customerInteractionSlice";

const CustomerInteraction = ({ themeColors }) => {
  const dispatch = useDispatch();
  const sliderRef = useRef(null);

  const { data, loading } = useSelector(
    (state) => state.customerInteraction || {}
  );

  useEffect(() => {
    dispatch(getCustomerInteractionRequest());
  }, [dispatch]);

  if (loading || !data || data.length === 0) return null;

  const sliderSettings = {
    dots: true,
    arrows: false, // we handle arrows manually
    infinite: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 2000,
    swipe: true,
    pauseOnHover: true,
    pauseOnFocus: true,
  };

  return (
    <Box sx={{ mt: { xs: 3, sm: 5 }, px: { xs: 1.5, sm: 3 } }}>
      {data.map((item) => (
        <Box key={item._id} sx={{ mb: 5, textAlign: "center" }}>
          {/* TITLE */}
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: { xs: "1.25rem", sm: "26px" },
              color: themeColors.primary,
            }}
          >
            {item.title}
          </Typography>

          {/* DESCRIPTION */}
          <Typography
            sx={{
              mt: 1,
              fontSize: "16px",
              color: themeColors.primary,
            }}
          >
            {item.description}
          </Typography>

          {/* MEDIA SLIDER */}
          {item.urls?.length > 0 && (
            <Card
              sx={{
                mt: 3,
                borderRadius: "25px",
                overflow: "hidden",
                maxWidth: 420,
                mx: "auto",
                boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
                position: "relative",
              }}
            >
              {/* LEFT BUTTON */}
              <IconButton
                onClick={() => sliderRef.current?.slickPrev()}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: 10,
                  transform: "translateY(-50%)",
                  zIndex: 2,
                  background: "rgba(0,0,0,0.5)",
                  color: "#fff",
                  "&:hover": { background: "rgba(0,0,0,0.7)" },
                }}
              >
                <ArrowBackIosNewIcon fontSize="small" />
              </IconButton>

              {/* RIGHT BUTTON */}
              <IconButton
                onClick={() => sliderRef.current?.slickNext()}
                sx={{
                  position: "absolute",
                  top: "50%",
                  right: 10,
                  transform: "translateY(-50%)",
                  zIndex: 2,
                  background: "rgba(0,0,0,0.5)",
                  color: "#fff",
                  "&:hover": { background: "rgba(0,0,0,0.7)" },
                }}
              >
                <ArrowForwardIosIcon fontSize="small" />
              </IconButton>

              <Slider {...sliderSettings} ref={sliderRef}>
                {item.urls.map((media) =>
                  media.mediaType?.includes("video") ? (
                    <video
                      key={media._id}
                      src={media.url}
                      autoPlay
                      muted
                      loop
                      playsInline
                      onPlay={() => sliderRef.current?.slickPause()}
                      onEnded={() => sliderRef.current?.slickPlay()}
                      style={{
                        width: "100%",
                        height: "420px",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <img
                      key={media._id}
                      src={media.url}
                      alt="customer interaction"
                      style={{
                        width: "100%",
                        height: "420px",
                        objectFit: "cover",
                      }}
                    />
                  )
                )}
              </Slider>
            </Card>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default CustomerInteraction;
